import { Card, CardInner } from "toddlar-ui";
import { useNavigate } from "react-router-dom";
import { type Toy } from "../services/api";

const ToyCard: React.FC<{ toy: Toy }> = ({ toy }) => {
  const navigate = useNavigate();
  const go = () => navigate(`/toy/${encodeURIComponent(toy.name)}`);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={go}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          go();
        }
      }}
      aria-label={`View ${toy.name}`}
      className="cursor-pointer"
    >
      <Card
        className="group relative overflow-hidden rounded-3xl border border-sand-200 bg-white transition
                       hover:-translate-y-0.5 hover:shadow-xl hover:ring-1 hover:ring-brand-500/30"
      >
        <CardInner className="p-4 sm:p-5">
          {/* Image frame */}
          <div className={`relative rounded-2xl overflow-hidden bg-white`}>
            <div className="absolute inset-0 pointer-events-none opacity-60 [mask-image:radial-gradient(white,transparent_70%)]" />
            <div className="aspect-square grid place-items-center p-4">
              <img
                src={toy.images?.[0] || ""}
                alt={toy.name}
                loading="lazy"
                className="max-h-full max-w-full object-contain drop-shadow-sm transition-transform duration-300
                         group-hover:scale-[1.03]"
              />
            </div>
          </div>

          {/* Content */}
          <div className="mt-4 flex flex-col gap-2">
            <h3 className="text-base font-semibold leading-tight text-ink">
              {toy.name}
            </h3>

            <p className="text-sm text-ink-muted line-clamp-3">
              {toy.description}
            </p>

            <div className="mt-1 flex items-center justify-between">
              <div className="text-brand-600 font-bold">{toy.category}</div>
              {/* subtle CTA affordance; wire up later if you add an action */}
              <button
                type="button"
                aria-label={`View ${toy.name}`}
                className="inline-flex items-center gap-1 text-sm font-medium text-brand-700 opacity-0
                         transition-opacity group-hover:opacity-100"
              >
                View
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="h-4 w-4"
                  aria-hidden="true"
                >
                  <path d="M7.5 5.5a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 11-2 0V7.914l-7.793 7.793a1 1 0 01-1.414-1.414L12.586 6.5H8.5a1 1 0 01-1-1z" />
                </svg>
              </button>
            </div>
          </div>
        </CardInner>
      </Card>
    </div>
  );
};

export default ToyCard;
